module.exports = __webpack_public_path__ + "img/mind_skeleton_33.ed7ad3c2.png";